import { addSeconds } from 'date-fns';

import zonedDate from './zoned-date';

// document.cookie holds every cookie on the domain, including ones we don't
// set. One stray % must not throw for all of them
function safeDecode(value) {
    try {
        return decodeURIComponent(value);
    } catch (error) {
        return value;
    }
}

/**
 *
 * @param {String} name
 * @returns {String|undefined}
 */
export function getCookie(name) {
    const cookies = document.cookie.split(';');

    for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i].split('=');

        if (safeDecode(cookie[0].trim()) === name) {
            return cookie.length ? safeDecode(cookie[1]) : '';
        }
    }

    return undefined;
}

/**
 *
 * @param {String} name
 * @param {String} value
 * @param {Date|Number|{expires: Date, path: String, domain: String, secure: Boolean}} options
 */
export function setCookie(name, value, options) {
    let cookie = encodeURIComponent(name) + '=' + encodeURIComponent(value);

    if (options && (options instanceof Date || typeof options === 'number')) {
        options = {
            expires: options,
        }
    }

    if (options && typeof options === 'object') {
        if (options.expires && options.expires instanceof Date) {
            cookie += '; expires=' + options.expires.toGMTString();
        } else if (options.expires) {
            const expires = parseInt(options.expires, 10);

            if (expires) {
                cookie += '; expires=' + addSeconds(zonedDate(), expires).toGMTString();
            }
        }

        if (options.path) {
            cookie += '; path=' + options.path.toString();
        } else {
            cookie += '; path=/;';
        }

        if (options.domain) {
            cookie += '; domain=' + options.domain.toString();
        }

        if (options.secure) {
            cookie += '; secure';
        }
    } else {
        cookie += '; path=/;';
    }

    document.cookie = cookie;
}

export function removeCookie(name) {
    setCookie(name, '', {
        expires: 0,
    });
}

export default {
    get: getCookie,
    set: setCookie,
    remove: removeCookie,
}
